import React from 'react';
import { ExternalLinkIcon, MapPinIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Reviews() {
  return <section id="reviews" className="scroll-mt-20 bg-white py-20 lg:py-28" aria-labelledby="reviews-title" data-id="element-223" data-mp="2mbozg0hadenw">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-224" data-mp="2raig21rvdlsa">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-225" data-mp="2rc389kqposmz">
          <div className="max-w-2xl" data-id="element-226" data-mp="2w9d5hmkce8ld">
            <h2 id="reviews-title" className="section-title" data-id="element-227" data-mp="30bgi4eiqzj88">
              Trusted by Central Florida Homeowners
            </h2>
            <p className="mt-4 text-lg text-ink/75" data-id="element-228" data-mp="351wxi464pex8">
              What homeowners in Orlando, Kissimmee, and Winter Garden say about their pool renovation.
            </p>
          </div>
          <a href="#reviews" className="btn-outline w-full md:w-auto" data-id="element-229" data-mp="3f0w65mqw9ak8">
            Read Our Google Reviews
            <ExternalLinkIcon className="h-4 w-4" aria-hidden="true" data-id="element-230" data-mp="3jyo16pmu5csn" />
          </a>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-231" data-mp="2rcxgt6iu31um">
          {testimonials.map(t => <li key={t.id} className="flex" data-id="element-232" data-mp="2mdb4czatxpmv">
              <figure className="flex w-full flex-col rounded-2xl bg-cyan-50 p-7 ring-1 ring-aqua/10" data-id="element-233" data-mp="2mc9jk340hory">
                <div className="flex items-center justify-between" data-id="element-234" data-mp="2hgkfbmh1rjpb">
                  <div className="flex gap-1" aria-label="5 out of 5 stars" data-id="element-235" data-mp="2de7jpqw0l269">
                    {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-4 w-4 fill-accent text-accent" aria-hidden="true" data-id="element-236" data-mp="3a59gfli3rp12" />)}
                  </div>
                  <QuoteIcon className="h-7 w-7 text-aqua/30" aria-hidden="true" data-id="element-237" data-mp="30ck82zhumr9y" />
                </div>
                <span className="mt-5 inline-flex w-fit rounded-md bg-white px-2.5 py-1 text-xs font-semibold text-aqua ring-1 ring-aqua/15" data-id="element-238" data-mp="2wap9i2rayrzv">
                  {t.service}
                </span>
                <blockquote className="mt-4 text-[15px] leading-relaxed text-ink/85" data-id="element-239" data-mp="3o2o9d07keexs">“{t.quote}”</blockquote>
                <figcaption className="mt-auto flex items-center gap-3 border-t border-aqua/15 pt-6" data-id="element-240" data-mp="1m6fhn63an7xr">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy font-display text-sm font-bold text-accent" aria-hidden="true" data-id="element-241" data-mp="1r35vrnvjftgj">
                    {initials(t.name)}
                  </span>
                  <span data-id="element-242" data-mp="13dv0un0vctab">
                    <span className="block font-semibold text-navy" data-id="element-243" data-mp="13dlct4zdww79">{t.name}</span>
                    <span className="flex items-center gap-1 text-sm text-ink/60" data-id="element-244" data-mp="18er8nbocczl0">
                      <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-245" data-mp="ths3dugypitp" />
                      {t.city}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(/\s|&/).filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase();
}